module.exports = __webpack_public_path__ + "static/beaver-mountain-zoom-b55cd3e1935ae21cd18fbfcc4580f828.jpg";